import { render, staticRenderFns } from "./controlSector.vue?vue&type=template&id=2de07cc1&scoped=true"
import script from "./controlSector.vue?vue&type=script&lang=js"
export * from "./controlSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de07cc1",
  null
  
)

export default component.exports